import logo from './logo.svg';
import './App.css';

import CheckboxDropdown from './CheckboxDropdown';
import {useEffect, useState, useRef} from 'react';
import { useLocation, useNavigate } from "react-router-dom";

function LLMOutput(props) {
  if (!props.isLoading && props.text.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center text-gray-500">
        <div className="w-28 h-28 animate-pulse bg-purple-200 rounded-full opacity-30" />
        <p className="mt-4">Welcome! Feel free to try out LLMs.</p>
      </div>

    );
  } else {
    return (
          <div className="relative h-[70vh]">
            <div className={`flex text-gray-500 h-full transition-all duration-300 ${props.isLoading ? 'opacity-50 blur-sm' : ''}`}>
              <TypingText text={props.text} />
            </div>

            <Loading isLoading={props.isLoading}></Loading>
          </div>

    );
  }
}

function Loading(props) {
  if (props.isLoading) {
    return (
      <div className="absolute inset-0 flex items-center justify-center zR-10">
        <div className="w-16 h-16 border-4 border-purple-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  } else {
    return <div></div>
  }
}

function TypingText({ text }) {
  const [displayed, setDisplayed] = useState("");
  const intervalRef = useRef(null);
  const containerRef = useRef(null);

  let speed = text.length > 50 ? 0 : 50;

  // setDisplayed("");

  useEffect(() => {
    setDisplayed(""); // 초기화

    let i = 0;

    // if (intervalRef.current) clearInterval(intervalRef.current);

    // intervalRef.current = setInterval(() => {
    //   setDisplayed((prev) => {
    //     // 다음 글자를 추가
    //     if (i < text.length) {
    //       const next = prev + text[i];
    //       i++;
    //       return next;
    //     } else {
    //       clearInterval(intervalRef.current);
    //       return prev;
    //     }
    //   });
    // }, speed);

    let delay = 100; // 초기 속도
    const acceleration = 0.9; // 0.9씩 곱하면 점점 빨라짐
    const minDelay = 5; // 너무 빠르지 않게 제한

    const typeNext = () => {
      if (i >= text.length) return;

      // 임계 지점에 도달하면 남은 전체 문자열을 한 번에 출력
      // const thresholdIndex = Math.floor(text.length * instantThreshold);
      if (i >= 3000) {
        setDisplayed(text);
        return;
      }

      setDisplayed(text.slice(0,i+1));
      i++;

      delay = Math.max(minDelay, delay * acceleration);
      intervalRef.current = setTimeout(typeNext, delay);
    };

    typeNext(); // 시작

    // setDisplayed(text);

    return () => clearTimeout(intervalRef.current);
  }, [text, speed]);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [displayed]);

  return (
    <div
      ref={containerRef}
      className='overflow-y-auto whitespace-normal max-h-[45vh] font-mono'>
      <span className="font-mono">
        {displayed}
        {/* <span className="animate-pulse">{displayed.length < text.length ? "|" : ""}</span> */}
      </span>
    </div>
  );
}

function PlaygroundUI() {

  const [model, setModel] = useState("Llama-Thunder-LLM_8B");
  const [maxTokens, setMaxTokens] = useState(128);
  const [temperature, setTemperature] = useState(1.0);
  const [topP, setTopP] = useState(0.9);
  const [inputText, setInputText] = useState("");
  const [outputText, setOutputText] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSend = async () => {
    setIsLoading(true);

    try {
      const res = await fetch("https://4c90-147-47-236-60.ngrok-free.app/generate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          model: model,
          text: inputText,
          maxTokens: maxTokens,
          temperature: temperature,
          topP: topP
        })
      });

      const data = await res.json();
      setOutputText(data.outputText);
      setInputText("");
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false); // 로딩 종료
    }
  };

  const handleKeyUp = (e) => {
    if (e.key === "Enter") {
      handleSend();
    }
  };

  return (
    <div className="flex flex-col lg:flex-row w-full h-[70vh] p-6 gap-6 bg-gray-50">
      {/* Left Panel */}
      <div className="flex-1 bg-white rounded-xl shadow-md p-6 flex flex-col justify-between">
        <div>
          <h2 className="text-lg font-semibold mb-6">Playground</h2>
        </div>

        <LLMOutput text={outputText} isLoading={isLoading}></LLMOutput>

        <div className="mt-8">
          <div className="flex items-center bg-gray-100 rounded-md px-4 py-3">
            <input
              type="text"
              value={inputText}
              onKeyUp={handleKeyUp}
              placeholder="Ask me anything :)"
              className="flex-1 bg-transparent focus:outline-none text-sm"
              onChange={e => setInputText(e.target.value)}
            />
            <button
              type="button"
              disabled={isLoading}
              className={`text-xs px-2 py-1 rounded ml-2 transition-colors duration-200
                ${isLoading
                  ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                  : 'bg-blue-500 text-white hover:bg-blue-600 active:bg-blue-700'
                }`}
              onClick={handleSend}
            >
              {isLoading ? 'Sending...' : 'Send'}
            </button>
          </div>
        </div>
      </div>

      {/* Right Panel */}
      <div className="w-full lg:w-80 bg-white rounded-xl shadow-md p-6">
        {/* <h3 className="text-md font-semibold mb-4">Control Bar</h3> */}

        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Model</label>
          <select className="w-full border border-gray-300 rounded px-2 py-1 text-sm" value={model} onChange={e => setModel(e.target.value)}>
            <option>Llama-Thunder-LLM_8B</option>
            <option>LLaMA3.1_8B</option>
            <option>EXAONE-3.5-Instruct_7.8B</option>
          </select>
        </div>

        <div className="mb-4">
          <label className="flex justify-between text-sm font-medium">
            Max Tokens <span>{maxTokens}</span>
          </label>
          <input type="range" min={0} max={2048} value={maxTokens} onChange={e => setMaxTokens(Number(e.target.value))} className="w-full" />
        </div>

        <div className="mb-4">
          <label className="flex justify-between text-sm font-medium">
            Temperature <span>{temperature}</span>
          </label>
          <input type="range" min={0} max={2} step={0.1} value={temperature} onChange={e => setTemperature(Number(e.target.value))} className="w-full" />
        </div>

        <div className="mb-4">
          <label className="flex justify-between text-sm font-medium">
            Top P <span>{topP}</span>
          </label>
          <input type="range" min={0} max={1} step={0.1} value={topP} onChange={e => setTopP(Number(e.target.value))} className="w-full" />
        </div>
      </div>
    </div>
  );
}

const COLORS = [
  "#fde68a", "#a5f3fc", "#c7d2fe", "#fbcfe8",
  "#bbf7d0", "#fecaca", "#ddd6fe", "#fcd34d",
  "#bae6fd", "#fdba74", "#f9a8d4", "#6ee7b7"
];

function calculateByteColors(text) {
  const encoder = new TextEncoder();
  const byteColors = [];
  for (const char of text) {
    const byteLength = encoder.encode(char).length;
    const colors = Array(byteLength).fill("#FFFFFF");
    byteColors.push(colors);
  }
  return byteColors;
};

function TokResult(props) {
  console.log(props.description);
  return (<div>
  <div style={{display: 'flex'}}>
    <div style={{ fontSize: 18, marginBottom: 5, marginTop: 10}}>
      <strong>Tokenizer: </strong> {props.option}
    </div>
    <div style={{ color: '#333', fontWeight: 'bold', fontSize: 18, marginLeft: 10, marginBottom: 5, marginTop: 10}}>
      (Token Count: {props.count ? props.count : 0})
    </div>
  </div>
  {/* <div>(Token Count: {props.count ? props.count : 0})</div> */}
  <div style={{ fontSize: 15, marginBottom: 10, color: "#888", fontWeight: 'bold'}}>
    {props.description}
  </div>
  <div style={{ position: "relative", width: "100%", height: 150, paddingBottom: 30}}>
    {/* <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        color: "#999",
        fontSize: 16,
        fontFamily: "inherit",
        textAlign: "center",
        pointerEvents: "none",
        zIndex: 0,
        whiteSpace: "pre-wrap",
        lineHeight: "1.5",
      }}
    >
      Token Count: {props.count}
  </div> */}
  <div className='p-4 bg-white rounded-lg shadow-md w-full h-[150px]'>
    {props.text.split('').map((token, idx) => {
      return (
        <span
          key={idx}
          style={{
            background: props.color[idx],
            display: "inline-block",
          }}
        >
          {token}
        </span>
      );
    })}
  </div>
  </div>
</div>);
}

function TokPlaygroundUI() {
  const [input, setInput] = useState("");
  const [text, setText] = useState("");
  const [colors, setColors] = useState({});
  const [tokenCount, setTokenCount] = useState({});

  const allOptions = ['BPE', 'Unigram', 'Thunder-Tok', 'Llama-Thunder-LLM', 'Llama3.1', 'EXAONE-3.5'];
  const descriptions = new Map([
    ['BPE', 'This is a 128k BPE tokenizer trained on the HPLT2.0 Korean dataset. It uses the same pre-tokenization method used in GPT-2.'],
    ['Unigram', 'This is a 128k Unigram tokenizer trained on the HPLT2.0 Korean dataset. It uses the same pre-tokenization method used in GPT-2.'],
    ['Thunder-Tok', 'This is a 128k Thunder-Tok trained on the HPLT2.0 Korean dataset.'],
    ['Llama-Thunder-LLM', "This tokenizer is used in Llama-Thunder-LLM. It extends Llama 3.1's tokenizer by incorporating around 92,000 Korean tokens, trained using the Thunder-Tok method."],
    ['Llama3.1', "This is the tokenizer used in Llama 3.1. It is trained on eight languages excluding Korean."],
    ['EXAONE-3.5', 'This is the tokenizer used in EXAONE-3.5. It is trained on Korean and English.'],
  ])
  const [selectedMainOptions, setSelectedMainOptions] = useState([]);

  const handleMainSelectionChange = (newSelection) => {
    setSelectedMainOptions(newSelection);
    setText("");
    setColors({});
    setTokenCount({});
  };


  const gradientColors = (colors) => {
    if (!colors || colors.length === 0) {
      return ""; // 색상이 없으면 빈 객체 반환
    }

    if (colors.length === 1) {
      return colors[0]; // 색상이 하나면 단색으로 처리
    }

    const gradientParts = colors.map((color, index) => {
      const start = (index / colors.length) * 100;
      const end = ((index + 1) / colors.length) * 100;
      return `${color} ${start.toFixed(2)}%, ${color} ${end.toFixed(2)}%`;
    });
    return `linear-gradient(to right, ${gradientParts.join(', ')})`
  }

  const input_colors = calculateByteColors(input);

  const getColor = (index) => {
    return COLORS[index % COLORS.length];
  };

  const handleTokenize = async () => {
    let new_colors = {}
    let new_counts = {}
    for (let idx in selectedMainOptions) {
      let option = selectedMainOptions[idx];
      // const res = await fetch("https://6129-147-47-200-81.ngrok-free.app/tokenize", {
      const res = await fetch("https://4c90-147-47-236-60.ngrok-free.app/tokenize", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text: input, tok: option })
      });

      const data = await res.json();
      let char_idx = 0
      let byte_idx = 0
      data.tokens.map((token, idx) => {
        let token_color = getColor(idx);
        for (let i = 0; i < token.length; i++) {
          input_colors[char_idx][byte_idx] = token_color;
          if (byte_idx + 1 === input_colors[char_idx].length) {
            char_idx += 1;
            byte_idx = 0;
          } else {
            byte_idx += 1;
          }
        }
      });
      let new_color = input.split('').map((token, idx) => gradientColors(input_colors[idx]));
      new_colors[option] = new_color;
      new_counts[option] = data.tokens.length;
    }
    setText(input);
    setColors(new_colors);
    setTokenCount(new_counts);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setInput(value);
  };

  return (
      <div className="min-h-screen bg-gray-100 flex flex-col items-center p-4 sm:p-6 lg:p-8 font-inter">
        <script src="https://cdn.tailwindcss.com"></script>
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap" rel="stylesheet" />

        <header className="w-full max-w-7xl bg-gradient-to-r from-blue-600 to-purple-600 p-4 rounded-lg shadow-lg mb-8 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0 sm:space-x-4">
          <h1 className="text-white text-3xl font-bold">Try Thunder-Tok!</h1>
          <nav className="flex space-x-4">
              <CheckboxDropdown
                options={allOptions}
                initialSelected={selectedMainOptions} // 초기 선택값을 props로 전달
                onSelectionChange={handleMainSelectionChange}
              />
          </nav>
        </header>

        {/* 페이지 내용 */}
        <main className="w-full max-w-7xl flex justify-center items-center">
          <div className="w-full max-w-7xl mx-auto mt-1 font-sans">
            <p style={{ color: "#888", paddingBottom: '15px', fontWeight: 'bold'  }}>Welcome to the Thunder-tok playground! This is your dedicated space to easily compare token counts and results from various tokenizers. </p>
            <textarea className='p-8 bg-white rounded-lg shadow-md w-full h-[150px]'
              rows={6}
              style={{ width: "100%", fontSize: 16, padding: 10, marginBottom: 12 }}
              placeholder="Enter your text here..."
              value={input}
              onChange={handleChange}
            />
            <div className="flex justify-center">
              <button
                onClick={handleTokenize}
                className="
                  bg-black text-white
                  px-10 py-3
                  text-base font-semibold
                  rounded-full
                  w-1/4
                  hover:bg-gray-800
                  active:bg-gray-900
                  transition-colors duration-200
                  cursor-pointer
                  shadow-md
                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black
                "
              >
                Tokenize
              </button>
            </div>
            <div>
              {selectedMainOptions.map((option) => { return (<TokResult option={option} count={tokenCount[option]} description={descriptions.get(option)} color={colors[option]} text={text}></TokResult>)})}
            </div>
          </div>
        </main>
      </div>
    );
}


function DeidPlaygroundUI() {
  const [modelSize, setModelSize] = useState("340M");
  const [inputText, setInputText] = useState("");
  const [outputText, setOutputText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [detectedEntities, setDetectedEntities] = useState([]);

  const handleSend = async () => {
    setIsLoading(true);
    try {
      // const res = await fetch("http://localhost:5000/deidentify", {
      const res = await fetch("https://4c90-147-47-236-60.ngrok-free.app/deidentify", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          text: inputText,
          model_size: modelSize
        })
      });

      const data = await res.json();
      setOutputText(data.deidentifiedText);
      setDetectedEntities(data.detectedEntities);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col w-full h-[60vh] p-6 gap-6 bg-gray-50">
      <div className="bg-white rounded-xl shadow-md p-6 flex flex-col justify-between">
        <h2 className="text-lg font-semibold mb-6">De-identification Playground</h2>

        {/* 입력창 */}
        <textarea
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          placeholder="Enter text to de-identify"
          className="w-full p-4 border border-gray-300 rounded mb-4"
          rows={4}
        />

        {/* 모델 사이즈 선택 */}
        <div className="flex items-center gap-4 mb-4">
          <label className="font-semibold">Model Size:</label>
          <select
            value={modelSize}
            onChange={(e) => setModelSize(e.target.value)}
            className="border px-2 py-1 rounded"
          >
            <option value="340M">340M</option>
            <option value="750M">750M</option>
            <option value="1.5B">1.5B</option>
          </select>
        </div>

        {/* 버튼 */}
        <button
          onClick={handleSend}
          disabled={isLoading}
          className={`px-6 py-2 rounded text-white font-semibold ${
            isLoading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          {isLoading ? "Processing..." : "De-identify"}
        </button>

        {/* 출력 결과 박스 */}
        <div className="mt-6">
          <label className="block text-sm font-semibold mb-1">De-identified Output</label>
          <div className="p-4 bg-white border rounded shadow-sm whitespace-pre-wrap text-sm h-32">
            {DeidHighlightedOutputWithColors(outputText, detectedEntities)}
          </div>
        </div>
      </div>
    </div>
  );
}

const ENTITY_COLORS = [
  "red", "blue", "green", "orange", "purple",
  "teal", "brown", "magenta", "darkgreen", "crimson",
  "darkblue", "goldenrod", "coral", "indigo", "maroon",
  "chocolate", "dodgerblue", "slateblue", "deeppink", "darkcyan"
];

export function DeidHighlightedOutputWithColors(text, detectedEntities = []) {
  if (!text) return "The results will be displayed here.";

  const regex = /[A-Z]{1,2}/g;
  const colorMap = new Map();
  let colorIndex = 0;

  const elements = [];
  let lastIndex = 0;

  for (const match of text.matchAll(regex)) {
    const start = match.index;
    const end = start + match[0].length;
    const token = match[0];

    // 일반 텍스트 추가
    if (start > lastIndex) {
      elements.push(text.slice(lastIndex, start));
    }

    // detectedEntities 목록에 있는 경우에만 색칠
    if (detectedEntities.includes(token)) {
      if (!colorMap.has(token)) {
        colorMap.set(token, ENTITY_COLORS[colorIndex % ENTITY_COLORS.length]);
        colorIndex++;
      }

      elements.push(
        <span
          key={start}
          style={{ color: colorMap.get(token), fontWeight: "bold" }}
        >
          {token}
        </span>
      );
    } else {
      // 일반 알파벳이지만 감지되지 않은 경우는 그냥 출력
      elements.push(token);
    }

    lastIndex = end;
  }

  if (lastIndex < text.length) {
    elements.push(text.slice(lastIndex));
  }

  return elements;
}

function App() {

  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname.replace("/", "") || "home";
  const [lang, setLang] = useState("ko");
  const isEnglish = lang === "en";

  if (path === 'inference/models') {
    return (
      <div className="min-h-screen bg-gray-100 flex flex-col items-center p-4 sm:p-6 lg:p-8 font-inter">
        <script src="https://cdn.tailwindcss.com"></script>
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap" rel="stylesheet" />

        <header className="w-full max-w-7xl bg-gradient-to-r from-blue-600 to-purple-600 p-4 rounded-lg shadow-lg mb-4 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0 sm:space-x-4">
          <h1 className="text-white text-3xl font-bold">Try Thunder-LLM!</h1>
        </header>

    <div className="w-full max-w-7xl bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 p-4 rounded-lg shadow mb-2 relative">
      {/* Language Switcher */}
      <div className="absolute top-2 right-4 space-x-2">
        <button
          onClick={() => setLang("ko")}
          className={`px-2 py-1 text-sm rounded ${!isEnglish ? "bg-yellow-300 font-bold" : "hover:underline"}`}
        >
          한국어
        </button>
        <button
          onClick={() => setLang("en")}
          className={`px-2 py-1 text-sm rounded ${isEnglish ? "bg-yellow-300 font-bold" : "hover:underline"}`}
        >
          English
        </button>
      </div>

      <p className="font-semibold">⚠️ {isEnglish ? "Please Note:" : "주의사항:"}</p>
      <ul className="list-disc list-inside mt-1 space-y-1 text-sm sm:text-base">
        {isEnglish ? (
          <>
            <li>
              During peak times, responses may be slow and may take several minutes to respond.
            </li>
            <li>
              As with other Korean-based foundational models, Thunder-LLM is not fine-tuned using chat data, so it may not provide accurate answers to conversational or chat-like questions.
            </li>
          </>
        ) : (
          <>
            <li>
              사용량이 많은 시간대는 응답이 느려질 수 있어서 응답까지 수 분이 걸릴수 있습니다.
            </li>
            <li>
              다른 한국어 기반 파운데이셔널 모델과 마찬가지로 Thunder-LLM은 채팅 데이터를 이용한 미세 조정을 하지 않았으므로 대화형 또는 채팅과 유사한 질문에 정확한 답을 제공하지 못할 수 있습니다.
            </li>
          </>
        )}
      </ul>
    </div>

        <main className="w-full max-w-7xl flex justify-center items-center flex-grow overflow-auto">
          <PlaygroundUI></PlaygroundUI>
        </main>
      </div>
    );
  } else if (path === "inference/tokenizers") {
    return (<TokPlaygroundUI></TokPlaygroundUI>);
  } else if (path === "inference/deid") {
    return (
      <div className="min-h-screen bg-gray-100 flex flex-col items-center p-4 sm:p-6 lg:p-8 font-inter">
        <header className="w-full max-w-7xl bg-gradient-to-r from-blue-600 to-purple-600 p-4 rounded-lg shadow-lg mb-4 flex justify-between items-center">
          <h1 className="text-white text-3xl font-bold">Try Thunder-DeID!</h1>
        </header>
        {/* <div className="w-full max-w-7xl bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 p-4 rounded-lg shadow mb-2">
        <p className="font-semibold">⚠️ 주의 사항:</p>
        <ul className="list-disc list-inside mt-1 space-y-1 text-sm sm:text-base">
          <li>
            <strong>본 시스템은 판결문 스타일의 현실적인 문장</strong>에 최적화되어 있습니다.
            <div className="mt-1 ml-4 text-sm text-gray-800 italic">
              예시: “피고인 홍길동은 2020. 7. 4. 23:50경 서울특별시 가상구 가상동에 있는 피해자 김가영(여, 51세)이 운영하는 포장마차에서, 사실은 ...”
            </div>
          </li>
          <li>
            <strong>일반 대화체, 문학체, 비현실적인 이름</strong>이 포함된 문장은 비식별 정확도가 낮아질 수 있습니다.
          </li>
          <li>
            <strong>너무 짧은 입력</strong>은 문맥 부족으로 성능이 저하될 수 있으니 <strong>2문장 이상</strong> 입력해 주세요.
          </li>
          <li>
            <strong>사용자가 많을 경우 응답이 지연</strong>될 수 있으니, 이 경우 잠시 후 다시 시도해 주세요.
          </li>
        </ul>
      </div> */}

    <div className="w-full max-w-7xl bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 p-4 rounded-lg shadow mb-2 relative">
      {/* Language Switcher */}
      <div className="absolute top-2 right-4 space-x-2">
        <button
          onClick={() => setLang("ko")}
          className={`px-2 py-1 text-sm rounded ${!isEnglish ? "bg-yellow-300 font-bold" : "hover:underline"}`}
        >
          한국어
        </button>
        <button
          onClick={() => setLang("en")}
          className={`px-2 py-1 text-sm rounded ${isEnglish ? "bg-yellow-300 font-bold" : "hover:underline"}`}
        >
          English
        </button>
      </div>

      <p className="font-semibold">⚠️ {isEnglish ? "Please Note:" : "주의사항:"}</p>
      <ul className="list-disc list-inside mt-1 space-y-1 text-sm sm:text-base">
        {isEnglish ? (
          <>
            <li>
              Thunder-DeID is optimized for the legal judgment style used in Korean court judgments.
              <div className="mt-1 ml-4 text-sm text-gray-800 italic">
                Example: “The defendant, Kim Cheol-su, on July 4, 2020, at approximately 23:50, at the "Urijip Beer" pub operated by the victim Kim Ga-young (female, age 51), located in Gasang-dong, Gasang-gu, Seoul, ordered alcoholic beverages and food despite having neither the intent nor the ability to pay, thereby unlawfully gaining property benefits worth approximately 50,000 KRW.”
              </div>
            </li>
            <li>
              Sentences in formats other than court judgments—such as casual conversation or those containing unrealistic names—may result in lower de-identification accuracy.
            </li>
            <li>
              Very short inputs may lack sufficient context, leading to reduced performance. Please enter at least two sentences.
            </li>
            <li>
              During peak times, responses may be slow and may take several minutes to respond.
            </li>
          </>
        ) : (
          <>
            <li>
              Thunder-DeID는 한국어 판결문 문체에 최적화되어 있습니다.
            </li>
            <div className="mt-1 ml-4 text-sm text-gray-800 italic">
              예시: “피고인 김철수는 2020. 7. 4. 23:50경 서울시 가상구 가상동에 있는 피해자 김가영(여, 51세)이 운영하는 우리집비어 주점에서, 사실은 비용을 지불할 의사나 능력이 없음에도 불구하고 술과 안주를 주문하여 5만원 상당의 재산상의 이득을 취하였다.”
            </div>
            <li>
              판결문 형식이 아닌 일반 대화나 비현실적인 이름이 포함된 문장 등은 비식별 정확도가 낮아질 수 있습니다.
            </li>
            <li>
              너무 짧은 입력은 문맥 부족으로 성능이 저하될 수 있으니 두 문장 이상 입력해 주세요.
            </li>
            <li>
              사용량이 많은 시간대는 응답이 느려질 수 있어서 응답까지 수 분이 걸릴수 있습니다.
            </li>
          </>
        )}
      </ul>
    </div>

        <main className="w-full max-w-7xl">
          <DeidPlaygroundUI />
        </main>
      </div>
    );
  } else {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-white gap-6 font-inter">
        <h2 className="text-2xl font-semibold">Choose a Playground</h2>
        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={() => navigate("/inference/tokenizers")}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
          >
            Tokenizer Playground
          </button>
          <button
            onClick={() => navigate("/inference/models")}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
          >
            Thunder-LLM Playground
          </button>
          <button
            onClick={() => navigate("/inference/deid")}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
          >
            De-identification Playground
          </button>
        </div>
      </div>
    );
  }
}

export default App;
